import EverTrue from 'app';
import BaseRouter from 'base/base-router';
import EmailTemplatesController from './controllers/email-templates-controller';
import SmsTemplatesController from './controllers/sms-templates-controller';
import IsFlaggedController from 'components/flags/is-flagged-controller';
import { EmailTemplatesProvider } from 'apps/outreach/email/templates/email-templates-context';
import { EmailSignaturesProvider } from 'apps/outreach/email/signatures/email-signatures-context';

/**
 * Router for Email Templates and SMS Templates pages.
 */
class EmailTemplatesRouter extends BaseRouter {
  static initClass() {
    this.prototype.routes = {
      'email-templates(/)': 'index',
      'sms-templates(/)': 'smsIndex',
    };
  }

  index() {
    EverTrue.track.set('email_templates', { type: 'index' });
    EverTrue.execute('setBrowserTitle', 'Email Templates');
    this.currentView = (
      <IsFlaggedController flag="signal">
        <EmailTemplatesProvider>
          <EmailSignaturesProvider>
            <EmailTemplatesController />
          </EmailSignaturesProvider>
        </EmailTemplatesProvider>
      </IsFlaggedController>
    );
    EverTrue.page.mount(this.currentView);
  }

  smsIndex() {
    EverTrue.track.set('sms_templates', { type: 'index' });
    EverTrue.execute('setBrowserTitle', 'SMS Templates');
    this.currentView = (
      <IsFlaggedController flag="signal">
        <SmsTemplatesController />
      </IsFlaggedController>
    );
    EverTrue.page.mount(this.currentView);
  }
}

EmailTemplatesRouter.initClass();
export default EmailTemplatesRouter;
